import './index.scss';

import { observer } from 'mobx-react';
import React from 'react';

import TypeOfClaimStore from './TypeOfClaimStore';
import Form from './Form';
import Modal from './Modal';
import router from '../../../stores/router';
import { debounce } from 'lodash';
import ui from '../../../stores/dashboard';
import dashboardStore from '@stores/dashboard';
import * as api from '@stores/api';

class TypeOfClaim extends React.Component {
  componentDidMount() {
    if (!api.isAdminOrMagStaffOrAccounting()) {
      dashboardStore.close('/view/add-edit-types-of-claims-2', true);
      return;
    }
    this._searchDebounced();
    ui.on('open(/view/add-edit-types-of-claims-2)', this._searchDebounced);
  }

  _searchDebounced = debounce(() => {
    const { search, state } = router.location;
    const Id = parseInt(search.slice(4));

    if (Id !== 0) {
      if (state) {
        const { record } = state;
        TypeOfClaimStore.setFieldsValue({
          dataClaim: {
            id: Id,
            name: record.Name || '',
            descriptions: record.Description || '',
            isActive: record.IsActive,
          },
        });
      }
    } else {
      TypeOfClaimStore.onReset();
    }
  }, 100);

  render() {
    const { open } = TypeOfClaimStore;

    return (
      <div className={`form-add-edit-container`}>
        <React.Fragment>
          <Form />
          {open && <Modal />}
        </React.Fragment>
      </div>
    );
  }
}

export default observer(TypeOfClaim);
